export default __webpack_public_path__ + "static/media/mozart3.48afad40.png";